import React from "react";
import Header from "@/components/vivasvan/Header";
import Hero from "@/components/vivasvan/Hero";
import Products from "@/components/vivasvan/Products";
import Logistics from "@/components/vivasvan/Logistics";
import Manifesto from "@/components/vivasvan/Manifesto";
import Contact from "@/components/vivasvan/Contact";
import Footer from "@/components/vivasvan/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#0A192F] text-bone">
      <Header />
      <main>
        <Hero />
        <Products />
        <Logistics />
        <Manifesto />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
